import type { Step } from "react-joyride";

export const categoryFormTourSteps: Step[] = [
  {
    target: "body",
    content: "ມາເບິ່ງການປ້ອນຂໍ້ມູນໃນການສ້າງ ຫຼື ແກ້ໄຂຫມວດມູ່.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="category-form-names"]',
    content:
      "ໃສ່ຊື່ຫມວດມູ່: ຮອງຮັບ 3 ພາສາ (ລາວ, ໄທ, ອັງກິດ), ຊື່ເຫຼົ່ານີ້ຈະສະແດງໃນຕາຕະລາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-slug"]',
    content:
      "Slug: ລະຫັດອ້າງອີງ URL ທີ່ບໍ່ຊໍ້າກັນ (ໃຊ້ຕົວພິມນ້ອຍ, ຕົວເລກ ແລະ ເຄື່ອງໝາຍຂີດກາງ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-parent"]',
    content:
      "ເລືອກຫມວດມູ່ແມ່: ຖ້າເປັນຫມວດມູ່ຍ່ອຍໃຫ້ເລືອກແມ່ຂອງມັນ, ຖ້າປະວ່າງຈະເປັນຫມວດມູ່ຫຼັກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-order"]',
    content:
      "ລຳດັບການສະແງ: ຕົວເລກນ້ອຍຈະສະແດງກ່ອນໃນລະດັບດຽວກັນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="category-form-submit"]',
    content: "ປຸ່ມບັນທຶກ: ກົດເພື່ອບັນທຶກຂໍ້ມູນທັງໝົດ.",
    placement: "top",
  },
];
